import { SectionComponentLayout, Text, Div, PillTags, LinkButton } from '@cbhq/cdx-components';
import { mapEntryLink } from '../../globals/navlink.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function NoResults({
  searchTerms = [],
  onSearch,
  noSearchResultsText,
  goBackLink
}) {
  const tags = searchTerms.map(term => ({
    label: term,
    onClick: onSearch ? () => onSearch(term) : undefined
  }));
  const linkProps = goBackLink ? mapEntryLink(goBackLink) : undefined;
  return /*#__PURE__*/jsxs(SectionComponentLayout, {
    hasSpacingHorizontal: true,
    children: [/*#__PURE__*/jsx(Text, {
      variant: "title4",
      color: "foregroundMuted",
      as: "p",
      children: /*#__PURE__*/jsx(Div, {
        as: "span",
        maxWidth: "900px",
        children: noSearchResultsText
      })
    }), tags && /*#__PURE__*/jsx(Div, {
      spacingTop: 4,
      spacingBottom: 7,
      maxWidth: "600px",
      children: /*#__PURE__*/jsx(PillTags, {
        tags: tags
      })
    }), linkProps && /*#__PURE__*/jsx(Div, {
      justifyContent: "center",
      children: /*#__PURE__*/jsx(LinkButton, {
        href: linkProps.url,
        children: linkProps.label
      })
    })]
  });
}
export { NoResults };
//# sourceMappingURL=NoResults.js.map
